/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Modal, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'

import { Editor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'

import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../../components/Custom/ConstituentSelect'
import ConstituentDetails from '../details'
import PaperSizeSelect from '../../../components/Custom/PaperSizeSelect'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			selectedOfficer: null,
			didSelectOfficer: false,
			editorState: null,
			selectedPaperSize: null
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
	
	componentDidMount() {
		const { selectedCertificate, isEdit, form } = this.props
		if (selectedCertificate) {
			const { setFieldsValue } = form

			let editorState = null
			const content = selectedCertificate.content
			if (content) {
				const contentBlock = htmlToDraft(content)
				if (contentBlock) {
					const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
					editorState = EditorState.createWithContent(contentState)
				}
			}
			this.setState({ editorState })

			if (isEdit && selectedCertificate) {
				setFieldsValue({
					constituent_uid: selectedCertificate.constituent_uid
				})
				this.setState({ selectedConstituent: { uid: selectedCertificate.constituent_uid, name: selectedCertificate.name, didSelectConstituent: false } })
			}
		}
	}

	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent, editorState, selectedPaperSize } = this.state
		const { form, AuthStore, saveCertificate, selectedCertificate, isEdit, onClose } = this.props
		const { barangay_uid } = AuthStore
		// const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			let content = null
			if (editorState) {
				content = draftToHtml(convertToRaw(editorState.getCurrentContent()))
			}
			const request_date = moment(values.request_date).format('YYYY-MM-DD HH:mm:ss')
			const ctc_date = moment(values.ctc_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid,
				name: (!selectedConstituent.didSelectConstituent) ? selectedConstituent.name : `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}`,
				constituent_uid: selectedConstituent.uid,
				request_date, ctc_date,
				content,
				paper_size: selectedPaperSize
			})
			if (isEdit && selectedCertificate) {
				params = Object.assign({}, params, { certificate_uid: selectedCertificate.uid })
			}
			console.log('params', params)

			message.loading({ key: 'set_certificate', content: 'Generating Certificate, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveCertificate(params).then((response) => {
					const { file_url } = response.data.setCustomCertificate
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_certificate', content: 'Certificate successfully generated.' })

					//create audit trail
					const auditParams = {
						module_name: 'Certificate',
						action: 'Create',
						message: 'Generate custom certificate'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error generating certificate')
					message.error({ key: 'set_certificate', content: err.message.replace('GraphQL error:', '') })
					// resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, AuthStore, selectedCertificate, isEdit } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid, or_required } = AuthStore
		const { selectedConstituent, isSaving, editorState } = this.state
		
		return (
			<Modal
				title="Custom Certificate"
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'90%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Generate'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<ConstituentDetails selectedConstituent={selectedConstituent} table_name='custom_certificates' />
					}
					<Row gutter={16}>
						<Col md={16} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select Constituent Name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Request Date'>
								{ getFieldDecorator('request_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='O.R. Number'>
								{ getFieldDecorator('or_number', {
									initialValue: (selectedCertificate && isEdit) ? selectedCertificate.or_number : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter OR Number' />
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='O.R. Amount'>
								{ getFieldDecorator('amount', {
									initialValue: (selectedCertificate && isEdit) ? selectedCertificate.amount : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='O.R. Issued Date'>
								{ getFieldDecorator('or_issued_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='CTC Number'>
								{ getFieldDecorator('ctc_number', {
									initialValue: (selectedCertificate && isEdit) ? selectedCertificate.ctc_number : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter CTC Number' />
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='CTC Amount'>
								{ getFieldDecorator('ctc_amount', {
									initialValue: (selectedCertificate && isEdit) ? selectedCertificate.ctc_amount : null,
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter CTC Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={4} sm={24}>
							<Form.Item label='CTC Date'>
								{ getFieldDecorator('ctc_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: false,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row gutter={16}>
						<Col md={12} sm={24}>
							<Form.Item label='Certificate Title'>
								{ getFieldDecorator('title', {
									initialValue: (selectedCertificate) ? selectedCertificate.title : null,
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter certificate title' />
								)}
							</Form.Item>
						</Col>
						<Col md={12} sm={24}>
							<Form.Item label='Paper Size'>
								{ getFieldDecorator('paper_size', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<PaperSizeSelect 
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedPaperSize: item })
											} else {
												this.setState({ selectedPaperSize: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
					</Row>
					<Row style={{ marginBottom: 200 }}>
						<Form.Item label='Custom Details'>
							{ getFieldDecorator('content', {
								rules: [{
									required: true,
									message: 'This field is required.'
								}, {
									validator: (rule, value, callback) => {
										if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
											callback('only white space detected.')
										}
										callback()
									}
								}]
							})
							(
								<Editor
								 	editorState={editorState}
									toolbarClassName="toolbarClassName"
									wrapperClassName="wrapperClassName"
									editorClassName="editorClassName"
								 	onEditorStateChange={(state) => this.setState({ editorState: state })}
								/>
							)}
						</Form.Item>
					</Row>
				</Form>
				{/* <div
					style={{
						position: 'absolute',
						right: 0,
						bottom: 10,
						width: '100%',
						borderTop: '1px solid #e9e9e9',
						padding: '10px 16px',
						background: '#fff',
						textAlign: 'center',
					}}
				>
					<button disabled={isSaving} type="button" className="btn btn-block btn-primary btn-rounded waves-effect waves-light" onClick={this.handleSubmit}>Save</button>
				</div> */}
			</Modal>
		)
	}
}

const GENERATE_CERTIFICATE = gql`
    mutation setCustomCertificate($input: JSON) {
		setCustomCertificate(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-generate-certificate' }),
	inject('AuthStore'),
	graphql(GENERATE_CERTIFICATE, {
		props({ mutate }) {
			return {
				saveCertificate(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['customCertificates']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
